const DEFAULT_SORT_KEYS = [
  "text",
  "label",
  "name",
  "fullName",
  "company_name",
  "LocationName",
  "CourierCompany",
  "Ingredient_name",
  "code",
  "id",
  "value",
];

const normalizeSortValue = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

const buildFullName = (item = {}) => {
  return [item.firstName, item.middleName, item.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
};

const readSortValue = (item, selector) => {
  if (typeof selector === "function") {
    return normalizeSortValue(selector(item));
  }

  return normalizeSortValue(item ? item[selector] : "");
};

export const sortSelectableItems = (items = [], selectors = []) => {
  if (!Array.isArray(items)) return [];

  const activeSelectors = [
    ...selectors,
    ...DEFAULT_SORT_KEYS,
    (item) => buildFullName(item),
    (item) => item && item.DeliveryMethod && item.DeliveryMethod.CourierCompany,
  ];

  return [...items].sort((leftItem, rightItem) => {
    const leftValue = activeSelectors
      .map((selector) => readSortValue(leftItem, selector))
      .find(Boolean) || "";
    const rightValue = activeSelectors
      .map((selector) => readSortValue(rightItem, selector))
      .find(Boolean) || "";

    return leftValue.localeCompare(rightValue, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  });
};
